import { render } from "./StudentProgram.vue?vue&type=template&id=b4a25b9c"
import script from "./StudentProgram.vue?vue&type=script&lang=js"
export * from "./StudentProgram.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__